import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const CreditBanner = () => {
  const [s, setS] = useState(null);
  const { pathname } = useLocation();
  useEffect(() => {
    const load = () => api.get("/system/llm-status").then((r) => setS(r.data)).catch(() => {});
    load();
    window.addEventListener("credit-updated", load);
    return () => window.removeEventListener("credit-updated", load);
  }, [pathname]);
  if (!s?.blocked && s?.credit_pause) {
    const p = s.credit_pause;
    return (
      <div data-testid="credit-pause-banner" className="bg-[#B42318] text-[#FAF7F2]">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-12 py-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
          <AlertTriangle className="w-4 h-4 shrink-0" strokeWidth={1.75} />
          <span className="flex-1 min-w-[240px]">Batch queue paused: estimated credit (US${Math.max(p.balance || 0, 0).toFixed(2)}) can't cover the next guide (about US${p.avg_cost.toFixed(2)}). Top up, then enter your new balance.</span>
          <Link to="/batch" data-testid="credit-pause-update-link" className="border border-[#FAF7F2] px-3 py-1.5 hover:bg-[#FAF7F2] hover:text-[#B42318] transition-colors whitespace-nowrap">Enter new balance</Link>
        </div>
      </div>
    );
  }
  if (!s?.blocked) return null;
  const resume = async () => {
    try { await api.post("/system/llm-status/clear"); setS(null); toast.success("Generation resumed. Retry failed guides from the Batch page."); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="credit-banner" className="bg-[#B42318] text-[#FAF7F2]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-12 py-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
        <AlertTriangle className="w-4 h-4 shrink-0" strokeWidth={1.75} />
        <span className="flex-1 min-w-[240px]">{s.source === "anthropic" ? `Your Anthropic credit ran out while writing ${s.town}, so guide generation is paused. Add credit at console.anthropic.com → Settings → Billing.` : `AI credit ran out while writing ${s.town}, so guide generation is paused. Add balance in Profile → Manage plan → Universal Key → Add Balance.`}</span>
        <button data-testid="credit-resume-button" onClick={resume} className="border border-[#FAF7F2] px-3 py-1.5 hover:bg-[#FAF7F2] hover:text-[#B42318] transition-colors whitespace-nowrap">I've added credit, resume</button>
      </div>
    </div>
  );
};
